import { createAsyncThunk } from "@reduxjs/toolkit";
import { addContentAPI, fetchWebContentAPI, fetchWebContentByTypeAPI } from "./webContentAPI";

// Adding Web Content
export const addContent = createAsyncThunk("webContent/addContent", async (params, { rejectWithValue }) => {
    try {
        const response = await addContentAPI(params)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Fetch Web Content
export const fetchWebContent = createAsyncThunk("webContent/fetchWebContent", async ( _, { rejectWithValue }) => {
    try {
        const response = await fetchWebContentAPI()
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Fetch Web Content By Type
export const fetchWebContentByType = createAsyncThunk("webContent/fetchWebContentByType", async ( type, { rejectWithValue }) => {
    try {
        const response = await fetchWebContentByTypeAPI(type)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})